<template>
  <div>
    <v-dialog
      class="rounded-xl"
      v-model="userForDeclineModal"
      persistent
      max-width="400px"
    >
      <v-card
        style="
          width: 100%;
          box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05) !important;
          border-radius: 12px;
        "
      >
        <v-card-title>
          <span class="gc-text-h6">{{ lang.actions.declineRequest }}</span>
        </v-card-title>
        <v-card-text class="pb-0 mb-4">
          <p>{{ lang.general.areYouSure }}</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            small
            text
            @click="closeDialogDecline()"
            elevation="0"
          >
            {{ lang.actions.close }}
          </v-btn>
          <v-btn small class="btn-bg" elevation="0" @click="declineRequest()">
            {{ lang.actions.decline }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row class="page-title-container">
      <v-col class="col-12">
        <h2 class="page-title">{{ lang.menuLinks.pendingRequests }}</h2>
      </v-col>
    </v-row>
    <v-row v-if="pendingList && pendingList.length" class="main-row">
      <v-col
        class="col-12 pb-0"
        v-for="(el, index) in pendingList"
        :key="index"
      >
        <v-card
          elevation="0"
          style="
            box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05) !important;
            border-radius: 12px;
          "
        >
          <v-card-text class="px-mobile-0">
            <v-row>
              <v-col class="col-2 col-md-2">
                <div class="mx-auto text-center img-container">
                  <v-avatar
                    :width="imageWidth"
                    :height="imageHeight"
                    min-height="40"
                    min-width="40"
                    color="grey"
                  >
                    <v-img
                      v-if="el.userImageUrl"
                      :src="el.userImageUrl"
                      :alt="'Image ' + el.byUserFullName"
                      :lazy-src="require('../assets/images/lazy-loading.png')"
                    ></v-img>
                    <div v-else class="initials">
                      {{ getFullNameInitials(el.byUserFullName) }}
                    </div>
                  </v-avatar>
                </div>
              </v-col>
              <v-col
                class="col-10 col-md-10 d-flex flex-column justify-space-between"
              >
                <div>
                  <div class="title">
                    <span class="font-weight-bold">{{
                      `${el.byUserFullName}`
                    }}</span>
                    <span class="subtitle-1">
                      {{ lang.pendingRequests.sendYouARequestFor }}
                    </span>
                    <span class="font-weight-bold">{{
                      `${el.deceasedName}`
                    }}</span>
                  </div>
                  <div class="mt-3 subtitle-1 font-italic">
                    {{ el.description }}
                  </div>
                </div>
                <div class="mt-6 d-flex justify-end">
                  <v-btn
                    text
                    color="primary"
                    elevation="0"
                    small
                    @click="showDeclineModal(el)"
                    >{{ lang.actions.decline }}</v-btn
                  >
                  <v-btn
                    class="btn-bg ml-2"
                    small
                    elevation="0"
                    @click="acceptRequest(el)"
                    >{{ lang.actions.accept }}</v-btn
                  >
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-pagination
        class="mt-4 mx-auto"
        v-model="listPayload.pageIndex"
        :length="myPendingRequests.totalPages"
        :total-visible="6"
        prev-icon="mdi-menu-left"
        next-icon="mdi-menu-right"
        @input="getPendingRequests()"
      ></v-pagination>
    </v-row>
    <v-row class="mx-0">
      <v-col
        class="px-0"
        v-if="
          myPendingRequests &&
          myPendingRequests.items &&
          myPendingRequests.items.length === 0
        "
      >
        <NoResult
          class="mt-0"
          :show="myPendingRequests.items.length === 0"
          :title="lang.pendingRequests.noRequest"
          :button="{ link: '/MemoriesWall', text: lang.actions.explore }"
        ></NoResult>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import helpers from "../plugins/helpers.js";
import NoResult from "../components/noResult";
export default {
  name: "PendingRequests",
  data() {
    return {
      imageWidth: 140,
      imageHeight: 140,
      userForDeclineModal: false,
      userForDecline: null,
      selectedUser: null,
      listPayload: {
        pageIndex: 1,
        limit: 6,
        currentUser: null,
      },
    };
  },
  components: {
    NoResult,
  },
  computed: {
    pendingList() {
      return this.myPendingRequests.items;
    },
    // userSelected() {
    //   return this.selectedUser;
    // },
    ...mapGetters("user", ["currentUser", "myPendingRequests"]),
    lang() {
      return this.$store.state.langObj || {};
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  mounted() {
    document.title = "Good Casper - Pending Requests";
    this.getPendingRequests(true);
    this.imageWidth = window.innerWidth < 1000 ? 40 : 140;
    this.imageHeight = window.innerWidth < 1000 ? 40 : 140;
    window.addEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.imageWidth = window.innerWidth < 1000 ? 40 : 140;
      this.imageHeight = window.innerWidth < 1000 ? 40 : 140;
    },
    getFullNameInitials(name) {
      return helpers.getFullNameInitials(name);
    },
    showDeclineModal(user) {
      this.userForDeclineModal = true;
      this.userForDecline = user;
    },
    getPendingRequests(resetPage = false) {
      if (resetPage) {
        this.listPayload.pageIndex = 1;
      }
      this.listPayload.currentUser = this.currentUser.id;
      this.$store.dispatch("user/getPendingRequests", this.listPayload);
    },
    declineRequest() {
      this.$store
        .dispatch("user/declineRequest", this.userForDecline.id)
        .then(() => {
          this.closeDialogDecline();
          this.getPendingRequests(true);
        });
    },
    closeDialogDecline() {
      this.userForDecline = null;
      this.userForDeclineModal = false;
    },
    acceptRequest(user) {
      var payload = {
        accepted: true,
        id: user.id,
      };
      this.$store.dispatch("user/acceptRequest", payload).then(() => {
        this.getPendingRequests(true);
      });
    },
    // selectUser(index = 0) {
    //   var x = [...this.myPendingRequests];
    //   if (this.myPendingRequests.length) {
    //     x.map((el, ind) => {
    //       if (ind === index) {
    //         el.selected = true;
    //       } else {
    //         el.selected = false;
    //       }
    //       return el;
    //     });
    //     this.selectedUser = x.filter((x) => x.selected)[0];
    //   } else {
    //     this.selectedUser = null;
    //   }
    // },
  },
};
</script>

<style lang="scss">
.initials {
  font-size: 24px;
  font-weight: 600;
  line-height: 40px;
}
.user-request {
  cursor: pointer;
}
.img-container {
  margin: 10px auto;
}

@media only screen and (max-width: 660px) {
  .initials {
    font-size: 18px;
  }
  .main-row {
    .px-mobile-0 {
      padding: 0 !important;
    }
    margin-top: 15px !important;
    .row {
      margin: 0 !important;
    }
    .col-2 {
      padding-right: 0 !important;
      padding-top: 7px !important;
    }
    .v-card__text {
      padding-top: 0;
      padding-bottom: 5px;
      .row {
        .col-12 {
          padding: 0 !important;
        }
      }
    }
    .img-container {
      width: 40px;
      height: 40px;
    }
    .title {
      line-height: 12px !important;
      span {
        font-size: 14px !important;
      }
    }
  }
}
</style>
